import { debounce } from 'lodash';
import classify from '../helpers/classify';

export const ID = 'cms-show-more';
export const LOGO = 'cms-show-more__logo';
export const TITLE = 'cms-show-more__title';
export const BUTTON = 'cms-show-more__button';
export const BUTTON_LABEL_MORE = 'cms-show-more__button-label--more';
export const BUTTON_LABEL_LESS = 'cms-show-more__button-label--less';
export const BUTTON_CONTAINER = 'cms-show-more__button-container';
export const BUTTON_CONTAINER_MORE = 'cms-show-more__button-container--more';
export const BUTTON_CONTAINER_LESS = 'cms-show-more__button-container--less';
export const ANIMATED = 'cms-show-more--animated';
export const EXPANDED = 'cms-show-more--expanded';
export const SEPARATOR = 'cms-show-more__separator';
export const SEPARATOR_HIDDEN = 'cms-show-more__separator--hidden';
export const PLUS_ICON = 'cms-show-more__plus-icon';
export const MINUS_ICON = 'cms-show-more__minus-icon';
export const PARAGRAPH = 'cms-show-more__paragraph';
export const PARAGRAPH_CONTAINER = 'cms-show-more__paragraph-container';
export const PARAGRAPH_CONTAINER_SHOWN = 'cms-show-more__paragraph-container--shown';
export const PARAGRAPH_CONTAINER_HIDDEN = 'cms-show-more__paragraph-container--hidden';
export const TOP_PADDING_DISABLED = 'cms-show-more--top-padding-disabled';

function initShowMore(showMore: HTMLDivElement): void {
  const buttons = showMore.querySelectorAll<HTMLButtonElement>(classify(BUTTON));
  const paragraphContainerHidden = showMore.querySelector<HTMLDivElement>(classify(PARAGRAPH_CONTAINER_HIDDEN));
  let isExpanded = showMore.classList.contains(EXPANDED);

  function handleClick(): void {
    if (!paragraphContainerHidden) {
      return;
    }

    const height = isExpanded ? 0 : paragraphContainerHidden.scrollHeight;

    paragraphContainerHidden.style.maxHeight = `${height}px`;
    isExpanded = !isExpanded;
    showMore.classList.toggle(EXPANDED);
  }

  buttons.forEach((button) => button.addEventListener('click', handleClick));

  window.addEventListener(
    'resize',
    debounce(() => {
      if (paragraphContainerHidden && isExpanded) {
        paragraphContainerHidden.style.maxHeight = `${paragraphContainerHidden.scrollHeight}px`;
      }
    }, 100)
  );
}

export default function initAllShowMore(): void {
  const showMoreComponents = document.querySelectorAll<HTMLDivElement>(classify(ID));
  showMoreComponents.forEach(initShowMore);
}
